export default class Filters {
  constructor() {
    this.$valid = [];
  }

  isValid() {
    return this.$valid.length;
  }

  addIsValid(bool) {
    this.$valid.push(bool.toString());

    return this;
  }

  resetIsValid() {
    this.$valid = [];

    return this;
  }
}
